import {
  IProfessionalRulesetCreateRequest,
  IProfessionalRulesetUpdateRequest,
} from "types/ProfessionalRuleset/ProfessionalRuleset";
import {
  IAllProfessionalRulesetResponse,
  IEndoFamiliesResponse,
  IProfessionalRulesetResponse,
} from "types/ProfessionalRuleset/ProfessionalRulesetResponse";

import { api } from ".";

const professionalRulesetQueries = api.injectEndpoints({
  endpoints: (builder) => ({
    getAllProfessionalRulesets: builder.query<
      IAllProfessionalRulesetResponse,
      void
    >({
      query: () => `professional-rulesets/all`,
      providesTags: ["ProfessionalRulesets"],
    }),
    getProfessionalRulesetById: builder.query<
      IProfessionalRulesetResponse,
      string
    >({
      query: (id) => `professional-rulesets/${id}`,
      providesTags: (_r, _e, id) => [
        { type: "ProfessionalRulesets", id: id ?? "LIST" },
      ],
    }),
    getEndoFamilies: builder.query<IEndoFamiliesResponse, void>({
      query: () => `professional-rulesets/endo-families`,
      providesTags: ["EndoFamilies"],
    }),
    getProfessionalRulesetForContract: builder.query<
      IProfessionalRulesetResponse,
      { providerId: string; payerId: number }
    >({
      query: ({ providerId, payerId }) =>
        `professional-rulesets/lookup?providerId=${providerId}&payerId=${payerId}`,
      providesTags: (_r, _e, { providerId, payerId }) => [
        {
          type: "ProfessionalRulesets",
          id: `${providerId}:${payerId}`,
        },
      ],
    }),
    createProfessionalRuleset: builder.mutation<
      IProfessionalRulesetResponse,
      IProfessionalRulesetCreateRequest
    >({
      query: (body) => ({
        url: "professional-rulesets",
        method: "POST",
        body,
      }),
      invalidatesTags: ["ProfessionalRulesets"],
    }),
    updateProfessionalRuleset: builder.mutation<
      IProfessionalRulesetResponse,
      IProfessionalRulesetUpdateRequest
    >({
      query: ({ id, ...body }) => ({
        url: `professional-rulesets/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["ProfessionalRulesets"],
    }),
    deleteProfessionalRuleset: builder.mutation<any, string>({
      query: (id) => ({
        url: `professional-rulesets/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["ProfessionalRulesets"],
    }),
  }),
});

export const {
  useGetAllProfessionalRulesetsQuery,
  useGetEndoFamiliesQuery,
  useGetProfessionalRulesetByIdQuery,
  useGetProfessionalRulesetForContractQuery,
  useCreateProfessionalRulesetMutation,
  useUpdateProfessionalRulesetMutation,
  useDeleteProfessionalRulesetMutation,
} = professionalRulesetQueries;
